import React, { useState, useEffect } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";

function StepImageMultiFileUploader_V4({ row, setRow }) {
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState(uuidv4());

    /**
     * 클라우디나리 업로드 다이렉트로 업로드
     */
    async function handleFileChange(e) {
        try {
            setLoading(true);
            const files = e.target.files;
            const uploadPromises = [];

            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                const formData = new FormData();

                formData.append("file", file);
                formData.append("upload_preset", "recipe");

                // 각 파일 업로드를 Promise로 생성하고 배열에 추가
                const uploadPromise = axios({
                    url: `https://api.cloudinary.com/v1_1/dgekrvesv/image/upload`,
                    method: "POST",
                    data: formData,
                }).then(({ data }) => {
                    return data.secure_url;
                });
                uploadPromises.push(uploadPromise);
            }

            // 모든 파일 업로드가 완료될 때까지 기다림
            const urls = await Promise.all(uploadPromises);

            // 모든 업데이트를 한 번에 처리
            const newSteps = [...row.steps];
            Array.from(files).forEach((f, i) => {
                const filename = f.name;
                const tmp = filename.split(".");

                // 확장자가 없는 경우 처리
                if (tmp.length < 2) {
                    console.log(`Invalid filename format: ${filename}`);
                    return;
                }

                const tmp2 = tmp[0].split("-");
                // // stepIndex-filenameSeq 형식이 아닌 경우 처리
                // if (tmp2.length < 2) {
                //     console.warn(`Invalid filename format: ${filename}`);
                //     return;
                // }

                const stepIndex = parseInt(tmp2[0]) - 1;
                const filenameSeq = 0;
                // const filenameSeq = parseInt(tmp2[1]) - 1;

                // NaN 체크
                if (isNaN(stepIndex) || isNaN(filenameSeq)) {
                    console.warn(`Invalid numbers in filename: ${filename}`);
                    return;
                }

                if (stepIndex >= 0 && stepIndex < newSteps.length && newSteps[stepIndex]) {
                    newSteps[stepIndex][`filename${filenameSeq}`] = urls[i];
                } else {
                    console.warn(`Step ${stepIndex + 1} does not exist for file: ${filename}`);
                }
            });

            // 마지막 이미지를 대표 이미지(row.filename0)로 설정
            const lastImageUrl = urls.length > 0 ? urls[urls.length - 1] : null;

            console.log(newSteps);

            // row.filename0만 업데이트 (steps는 파일명 기반으로 이미 할당됨)
            setRow({
                ...row,
                filename0: lastImageUrl || row.filename0, // 마지막 이미지를 대표 이미지로 설정
                steps: newSteps
            });
        } catch (error) {
            console.error("File upload error:", error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <input id={`file_${id}`} type="file" multiple onChange={handleFileChange} style={{ display: "none" }} />
            {loading ? (
                <div style={{ width: "114px" }} className="d-flex justify-content-center align-items-center">
                    <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <label htmlFor={`file_${id}`} className="w-100 btn btn-sm btn-primary text-white p-2">
                    <i className="bi bi-images me-1"></i>
                    스텝사진일괄등록
                </label>
            )}
        </>
    );
}

export default StepImageMultiFileUploader_V4;
